import { MesiEnum } from "../enum/mesi-enum";
import { SettoreDTO } from "./settoreDTO";

export class DatiReportorioManualiDTO {
  segnatura: string;
  id: string;
  numero: string;
  data: string;
  anno: string;
  mese: MesiEnum;
  privato: boolean;
  struttureAggiuntive: SettoreDTO[];
}
